var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Export',{attrs:{"can_generate":false,"date_filter":false,"default_type_value":null,"entities":_vm.entities,"file_types":_vm.file_types,"title":'Student FTE File 68',"type":'edudex',"edudex_date_filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }